// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user/auth-log/auth-log.component.scss","webpack://./../../audit%20module/RedThread/src/app/pages/user/auth-log/auth-log.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;ACCF","sourcesContent":["table {\r\n  width: 100%;\r\n}\r\n\r\n","table {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
